/*
 * Bundle entrypoint.
 *
 * The runtime is intentionally registered from one place so the build output
 * always exposes a single global widget API with build metadata baked into the
 * bundle banner and runtime metadata fields.
 */
declare const __WIDGET_VERSION__: string;
declare const __WIDGET_API_VERSION__: string;
declare const __WIDGET_BUILD_TIMESTAMP__: string;

import type { WidgetGlobal } from "./runtime/types";
import { registerWidgetGlobal } from "./runtime/widget-runtime";

const widgetGlobal = globalThis as unknown as WidgetGlobal;
const currentScript = widgetGlobal.document.currentScript;

if (
  currentScript &&
  "src" in currentScript &&
  typeof currentScript.src === "string"
) {
  widgetGlobal.__LPUWidgetScriptUrl = currentScript.src;
}

registerWidgetGlobal(widgetGlobal, {
  version: __WIDGET_VERSION__,
  apiVersion: __WIDGET_API_VERSION__,
  buildTimestamp: __WIDGET_BUILD_TIMESTAMP__,
});
